var map = {
	"./stadium10X.jpg": 1106,
	"./stadium11X.jpg": 3721,
	"./stadium12X.jpg": 4568,
	"./stadium13X.jpg": 279,
	"./stadium14X.jpg": 7934,
	"./stadium15X.jpg": 9173,
	"./stadium1X.jpg": 8584,
	"./stadium2X.jpg": 5257,
	"./stadium3X.jpg": 818,
	"./stadium4X.jpg": 9507,
	"./stadium5X.jpg": 1412,
	"./stadium6X.jpg": 7413,
	"./stadium7X.jpg": 3550,
	"./stadium8X.jpg": 8751,
	"./stadium9X.jpg": 5648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3598;